/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * RepoSpecType is the type of the repository.
 */
export enum RepoSpecType {
  RepoSpecTypeGit = 'git',
  RepoSpecTypeHttp = 'http',
  RepoSpecTypeOci = 'oci',
}
